export const OFFER_SCORE_CHART_STYLES = {
  lg: {
    mask: {
      height: 'calc(100% - 10px)',
      width: '130px',
      minWidth: '130px',
      borderRadius: '150px 150px 0 0',
      top: '10px',
      left: '10px',
    },
    background: {
      height: '80px',
      width: '150px',
      minWidth: '150px',
      borderRadius: '150px 150px 0 0',
    },
    stick: {
      borderRadius: '8px',
      height: '10px',
      width: '40px',
    },
    textContainer: {
      gap: 1,
      mt: '10px',
    },
    scoreText: {
      fontSize: '50px',
      fontWeight: 'medium',
    },
    scoreTextSmall: {
      fontSize: '24px',
      fontWeight: 'medium',
    },
    tbdText: {
      fontSize: '2xl',
      fontWeight: 'medium',
    },
  },
  md: {
    mask: {
      height: 'calc(100% - 6px)',
      width: '88px',
      minWidth: '88px',
      borderRadius: '100px 100px 0 0',
      top: '6px',
      left: '6px',
    },
    background: {
      height: '60px',
      width: '100px',
      minWidth: '100px',
      borderRadius: '100px 100px 0 0',
    },
    stick: {
      borderRadius: '6px',
      height: '8px',
      width: '30px',
    },
    textContainer: {
      gap: 1,
      mt: '7px',
    },
    scoreText: {
      fontSize: '40px',
      fontWeight: 'medium',
    },
    scoreTextSmall: {
      fontSize: '20px',
      fontWeight: 'medium',
    },
    tbdText: {
      fontSize: 'xl',
      fontWeight: 'medium',
    },
  },
  sm: {
    mask: {
      height: 'calc(100% - 4px)',
      width: '46px',
      minWidth: '46px',
      borderRadius: '54px 54px 0 0',
      top: '4px',
      left: '4px',
    },
    background: {
      height: '29px',
      borderRadius: '54px 54px 0 0',
      width: '54px',
      minWidth: '54px',
    },
    stick: {
      borderRadius: '4px',
      height: '2px',
      width: '9px',
    },
    textContainer: {
      gap: 0.5,
      mt: '6px',
    },
    scoreText: {
      fontSize: '18px',
      fontWeight: 'medium',
    },
    scoreTextSmall: {
      fontSize: 'xs',
      fontWeight: 'medium',
    },
    tbdText: {
      fontSize: 'sm',
      fontWeight: 'medium',
    },
  },
};
